import { useBlockProps, useInnerBlocksProps } from '@wordpress/block-editor';
import classNames from 'classnames';

export default function save({ attributes }) {
  const blockProps = useBlockProps.save();
  const { children, ...innerBlocksProps } = useInnerBlocksProps.save({
    className: classNames(
      'b_ai-generated',
      attributes.biteClass,
      attributes.flexClass
    ),
  });

  return (
    <div {...blockProps}>
      <div {...innerBlocksProps}>{children}</div>
    </div>
  );
}
